module.exports = __webpack_public_path__ + "static/media/Jared.699f7626.png";